module.exports = __webpack_public_path__ + "static/img/6_2.ed07fd62.jpg";